let loginWithFacebookBtn = document.getElementById("login-with-facebook");
let loginWithGoogleBtn = document.getElementById("login-with-google");

loginWithFacebookBtn.addEventListener("click", loginWithFacebookBtnClick)
loginWithGoogleBtn.addEventListener("click", loginWithGoogleBtnClick)

let googleAuth = undefined;

let facebookLoginConnectedStatus = { status: 'unkown', authResponse: {} };

let agent = {
    name: undefined,
    email: undefined,
    region: undefined,
}

loadJsFile();

function facebookLoginInit() {
    window.fbAsyncInit = function () {
        window.FB.init({
            appId: window.facebook_appId,
            status: true,
            cookie: true,
            xfbml: true,
            version: 'v12.0',
        });
        showLoignButton('facebook');
    };
}

function googleLoginInit() {
    gapi.load('auth2', () => {
        gapi.auth2.init({
            client_id: '603609326642-duielvhc4r4k8euui922585tua36g3ej.apps.googleusercontent.com',
            fetch_basic_profile: true,
        }).then(() => {
            googleAuth = gapi.auth2.getAuthInstance();
            showLoignButton('google');
        }, (err) => {
            console.log(err);
            // $.growl.error({
            //     title: "",
            //     message: "Please refresh the page",
            //     location: "tr",
            // });
        });
    });
}

function loginWithFacebookBtnClick() {
    showLoignButtonLoading('facebook', true);

    window.FB.getLoginStatus((res) => {
        if (res.status === 'connected') {
            _3rdPartyLogin('facebook', res.authResponse);

        } else {
            window.FB.login(
                function (res) {
                    if (res.status === 'connected') {
                        _3rdPartyLogin('facebook', res.authResponse);
                    } else {
                        showLoignButtonLoading('facebook', false);
                        $.growl.error({
                            title: "",
                            message: "Someting went wrong, Please try again. ",
                            location: "tr",
                        });
                        facebookLoginConnectedStatus = {
                            ...facebookLoginConnectedStatus,
                            status: 'unkown',
                        }
                    }
                },
                // We don't hvae user_location scope right now
                { scope: 'public_profile,email' }
            );
        }
    });
}

function loginWithGoogleBtnClick() {
    showLoignButtonLoading('google', true);

    googleAuth.signIn().then(googleUser => {
        _3rdPartyLogin('google', {id_token: googleUser.getAuthResponse().id_token});
    }, () => {
        $.growl.error({
            title: "",
            message: "Someting went wrong, Please try again. ",
            location: "tr",
        });
        showLoignButtonLoading('google', false);
    })
}

function _3rdPartyLogin(platform, payload) {
    $.ajax({
        url: '/api/3rd-party-login/user-info',
        data: { type: platform, ...payload },
        success: function(data) {
            if (data.error) {
                showLoignButtonLoading('facebook', false);
                showLoignButtonLoading('google', false);
                window.FB.logout();
                $.growl.error({
                    title: "",
                    message: "Someting went wrong, Please try again. ",
                    location: "tr",
                });
                return;
            }

            if (
                !data.result.is_registered &&
                data.result.can_register
            ) {

                agent.name = data.result.name;
                agent.email = data.result.email;
                agent.region = data.result.region_name;
                showRegionPopup(platform, data.result.region_name);

            } else if (data.result.is_registered) {
                window.location = data.result.login_url;
            }
        },
        error: function() {
            showLoignButtonLoading('facebook', false);
            showLoignButtonLoading('google', false);
            window.FB.logout();
            $.growl.error({
                title: "",
                message: "Someting went wrong, Please try again. ",
                location: "tr",
            });
        }
    })
}

function populate_register_form(name, email, city, brokerage, recaptcha, registerType) {
    $("#3party_register_form input[name=name]").val(name);
    $("#3party_register_form input[name=email]").val(email);
    $("#3party_register_form input[name=city]").val(city);
    $("#3party_register_form input[name=organization_name]").val(brokerage);
    $("#3party_register_form input[name=g-recaptcha-response]").val(recaptcha);
    $("#3party_register_form input[name=register_type]").val(registerType);
    $("#3party_register_form").submit();
    // $.ajax({
    //     method: 'POST',
    //     url: '/api/landing/same-domain-register',
    //     data: {
    //         source: "login-page",
    //         email,
    //         fullName: name,
    //         agentArea: regionName,
    //         brokerage,
    //     },
    //     success: function(data) {
    //         if (data.error) {
    //             showLoignButtonLoading(false);
    //             alert("Please try again");
    //             return;
    //         }

    //         window.location = data.result;
    //     },
    //     error: function() {
    //         showLoignButtonLoading(false);
    //         alert("Please try again");
    //     }
    // })
}

function loadJsFile() {
    if (!document.body.querySelector('#fb-login-script')) {
        const fbLoginScript = document.createElement('script');
        fbLoginScript.id = 'fb-login-script';
        fbLoginScript.src = 'https://connect.facebook.net/en_US/sdk.js';
        fbLoginScript.onload = facebookLoginInit;
        document.body.appendChild(fbLoginScript);
    }

    if (!document.body.querySelector('#google-login-script')) {
        const googleLoginScript = document.createElement('script');
        googleLoginScript.id = 'google-login-script';
        googleLoginScript.src = 'https://apis.google.com/js/platform.js';
        googleLoginScript.onload = googleLoginInit;
        document.body.appendChild(googleLoginScript);
    }
}

function showLoignButton(type) {
    if (type === 'facebook') {
        loginWithFacebookBtn.classList.remove('hide');
    } else if (type === 'google') {
        loginWithGoogleBtn.classList.remove('hide');
    }

    if (document.querySelector('.form-login_buttons .or'))
        document.querySelector('.form-login_buttons .or').classList.remove('hide');

    if (document.querySelector('.or-3party'))
        document.querySelector('.or-3party').classList.remove('hide');
}

function showLoignButtonLoading(type, status) {
    let button = type === 'facebook' ? loginWithFacebookBtn : loginWithGoogleBtn;

    if (status) {
        button.classList.add('button--loading');
        button.setAttribute('disabled', true);
    } else {
        button.classList.remove('button--loading');
        button.removeAttribute('disabled');
    }
}

function showRegionPopup(platform, defaultRegion) {
    showSelectRegionPopup(function(city, brokerageName, recaptcha) {
        if (city && brokerageName && recaptcha) {
            populate_register_form(agent.name, agent.email, city, brokerageName, recaptcha, platform);
        } else {
            $.growl.error({
                title: "",
                message: "Someting went wrong, Please try again. ",
                location: "tr",
            });
            showLoignButtonLoading(platform);
        }
    }, defaultRegion);
}